import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { Root } from './Tab.styles'

/**
 * The Tab's component.
 */
const Tab = props => {
  const { children, disabled, id, label, value, onRegister, ...restProps } = props

  useEffect(() => onRegister({ disabled, id, label }), [disabled, id, label, onRegister])

  return (
    <Root hidden={value !== id} role="tabpanel" {...restProps}>
      {value === id && children}
    </Root>
  )
}

Tab.defaultProps = {
  disabled: false,
  margin: 0,
  padding: 0,
  value: '',
  onRegister: () => undefined
}

Tab.propTypes = {
  /**
   * Children.
   */
  children: PropTypes.node.isRequired,
  /**
   * Disabled.
   */
  disabled: PropTypes.bool,
  /**
   * Id.
   */
  id: PropTypes.string.isRequired,
  /**
   * Label.
   */
  label: PropTypes.node.isRequired,
  /**
   * Margin.
   */
  margin: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * Padding.
   */
  padding: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * Value [private].
   */
  value: PropTypes.string,
  /**
   * On register [private].
   */
  onRegister: PropTypes.func
}

export default Tab
